"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";

import { PanelBackButton } from "@/components/layout/sidebar/mobile/panel-back-button";
import { Icon } from "@/components/ui/icon";
import { COPY } from "@/features/conversations/lib/copy";
import {
  resolveMeetingsTab,
  visibleMeetingsTabs,
} from "@/features/conversations/lib/routes";
import { cn } from "@/lib/utils";
import { useSidebar } from "@/stores/sidebar-store";

export function ConversationsPanel({ onBack }: { onBack: () => void }) {
  const searchParams = useSearchParams();
  const { setOpenMobile } = useSidebar();
  const activeTab = resolveMeetingsTab(searchParams.get("tab"));

  return (
    <nav aria-label={COPY.area} className="flex flex-col gap-0.5 px-3.5 py-2.5">
      <PanelBackButton onBack={onBack} />

      {visibleMeetingsTabs().map((tab) => {
        const href = `/conversations?tab=${tab}`;
        const active = activeTab === tab;
        return (
          <Link
            key={tab}
            href={href}
            aria-current={active ? "page" : undefined}
            onClick={active ? () => setOpenMobile(false) : undefined}
            className={cn(
              "flex h-8 w-full items-center gap-2 rounded-md px-2 transition-colors",
              active
                ? "sidebar-active text-heading"
                : "text-contrast/65 hover:bg-contrast/4 hover:text-heading",
            )}
          >
            <Icon
              name="IconVideo"
              size={16}
              className={cn(
                "size-4 shrink-0 text-contrast",
                active ? "opacity-90" : "opacity-[0.45]",
              )}
            />
            <span className="flex-1 truncate text-sm font-medium leading-5">
              {COPY.tabs[tab]}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
